export default __webpack_public_path__ + "static/media/3.77295fea.webp";